export type RouteDefinition = {
    PATH: string;
    NAME: string;
}

export const ROUTE = {
    PUBLIC_STARTPAGE: {
        PATH: "/",
        NAME: "PublicStartpage"
    },
    PUBLIC_ERROR_PAGE: {
        PATH: "/error",
        NAME: "PublicErrorPage"
    },
    PUBLIC_PAGE_NOT_FOUND: {
        PATH: "/404",
        NAME: "PublicPageNotFound"
    },
    PUBLIC_PAGE_NOT_ALLOWED: {
        PATH: "/403",
        NAME: "PublicPageNotAllowed"
    },
    AUTHENTICATION_CALLBACK: {
        PATH: "/auth/callback",
        NAME: "AuthenticationCallback"
    },
    RESTRICTED_AREA: {
        PATH: "/r",
        NAME: "RestrictedArea"
    },
    RESTRICTED_DOCUMENTS_LIST: {
        PATH: "/r/documents",
        NAME: "RestrictedDocumentsList"
    },
    RESTRICTED_DOCUMENTS_DOWNLOAD: {
        PATH: "/r/documents-download",
        NAME: "DocumentsDownload"
    },
    RESTRICTED_DOCUMENTS_DOWNLOAD_LIST: {
        PATH: "/r/documents-download/list",
        NAME: "DocumentsDownloadList"
    },
    RESTRICTED_DOCUMENTS_DOWNLOAD_SEND_MAIL: {
        PATH: "/r/documents-download/send-mail",
        NAME: "DocumentsDownloadSendMail"
    },
    RESTRICTED_DOCUMENTS_DOWNLOAD_SEND_MAIL_SUCCESS: {
        PATH: "/r/documents-download/send-mail/success",
        NAME: "DocumentsDownloadSuccess"
    },
    RESTRICTED_DOCUMENTS_DOWNLOAD_SEND_MAIL_FAILURE: {
        PATH: "/r/documents-download/send-mail/failure",
        NAME: "DocumentsDownloadFailure"
    },
    PUBLIC_UPTIME_STATUS: {
        PATH: "/status",
        NAME: "UptimeStatus"
    }

} as const;

export type RouteDefinitions = typeof ROUTE;
